import React from 'react';
import ChatWidget from './ChatWidget';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <a href="https://intellyx.com" target="_blank" rel="noopener noreferrer">
            <img 
              src={`${process.env.PUBLIC_URL}/images/intellyx-logo.png`} 
              alt="Intellyx Logo" 
              className="logo"
            />
          </a>
        </div>
      </header>

      {/* Banner */}
      <section 
        className="banner"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/black-bg.jpg)`
        }}
      >
        <div className="banner-container">
          <h1 className="banner-title">Intellyx Brain Chat</h1>
        </div>
      </section>

      {/* Main Content */}
      <main className="main-content">
        <div className="content-container">
          <div className="two-columns">
            {/* Left Column - Welcome Text */}
            <div className="welcome-column">
              <h2>Welcome to Intellyx Brain Chat!</h2>
              
              <p>
                We've digitally transformed our thought leadership content into a GenAI information resource. Just select your favorite Intellyx Analyst, or All Intellyx for all three of us, and ask any enterprise software-related questions you have.
              </p>
              
              <p className="disclaimer">
                Responses, while trained on Intellyx content from 2022 to 2025, are for demonstration purposes only, may be outdated, and should not be taken as business advice. All AI-generated content is authored by ©Intellyx B.V. and commercial reuse or sharing is prohibited without Intellyx permission, please contact <a href="mailto:pr@intellyx.com">pr@intellyx.com</a> if you would like to share or quote from this resource.
              </p>
            </div>
            
            {/* Right Column - Chat */}
            <div className="chat-column">
              <ChatWidget />
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <p>© Intellyx BV. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;